/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen200,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequestSchema =
  z.array(
    z.number().int(),
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse>;
